export const initExpandedInput = () => {
    const expandedSearch = document.querySelectorAll('.js-expanded-search');

    if (!expandedSearch) return;

    expandedSearch.forEach(search => {
        const expandBtn = search.querySelector('.js-search-expanded-open');
        const closeBtn = search.querySelector('.js-search-expanded-close');
        const container = search.closest('.js-search-container');
    
        expandBtn.addEventListener('click', (e) => {
            if (expandBtn.classList.contains('closed')) {
                e.preventDefault()
                search.classList.remove('closed')
                expandBtn.nextElementSibling.classList.add('expand')
                expandBtn.classList.remove('closed')
                setTimeout(() => container.classList.add('opened'), 300)
                const input = document.querySelector('#search-form');
                if (input) input.focus();
            }else {
                search.submit()
            }
        })
    
        closeBtn.addEventListener('click', () => {
            const searchBlock = closeBtn.closest('.js-search-expanded-input');
            
            if(searchBlock.classList.contains('expand')) {
                search.classList.add('closed')
                container.classList.remove('opened')
                setTimeout(() => { searchBlock.classList.remove('expand') }, 400)
                expandBtn.classList.add('closed')
            }
        })
    })
}